import { Routes, Route } from "react-router-dom";
import "./styles/App.scss";
import { Footer, Header, Home } from "./layout";
import { PaymentFailure, PaymentSuccess, PrivacyPolicy } from "./pages";

export const App = () => {
  return (
    <main className="app">
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-failure" element={<PaymentFailure />} />
      </Routes>
      <Footer />
    </main>
  );
};
